import axios, { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { QueryClient } from "react-query";
import { message, notification } from "antd";
export const PATH = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const NEST_REST_URL = process.env.REACT_APP_NEST_REST_URL || "http://localhost:3000";

export const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("accessToken");
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const autoLogout = () => {
  Cookies.remove("accessToken");
  notification.error({
    message: "Token autoryzacyjny wygasł, zaloguj się ponownie",
  });
  setTimeout(() => {
    window.location.reload();
  }, 3000);
};

export const getTasksStats = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/tasks-stats`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const deleteAttach = async (attach_id: number): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.delete<any>(
      `${NEST_REST_URL}/attachments/${attach_id}/`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};
export const getModel = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/data-models`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAddModalControls = async (id: number): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/data-models/${id}`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const reactQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
    },
  },
});

export const getTasks = async (filters: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/tasks?${filters}`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const getCalendarTasks = async (
  data: {
    first_calendar_day: string;
    last_calendar_day: string;
  },
  filters: any
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      `${PATH}/tasks-calendar/?${filters}`,
      data
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const addTask = async (data: { id: any; body: any }): Promise<any> => {
  return await axiosInstance.post<any>(`${PATH}/tasks/`, data.body);
};

export const getGetTaskDetails = async (id: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/tasks/${id}`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const getComments = async (id: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/comments/task/${id}`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const addComment = async (data: {
  task: any;
  comment: any;
}): Promise<any> => {
  return await axiosInstance.post<any>(`${NEST_REST_URL}/comments`, data);
};

export const updateComment = async (data: { id: any; comment: any }) => {
  return await axiosInstance.patch<any>(
    `${NEST_REST_URL}/comments/${data.id}`,
    { comment: data.comment }
  );
};

export const deleteComment = async (id: any): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.delete<any>(
      `${NEST_REST_URL}/comments/${id}`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const login = async (data: {
  username: any;
  password: any;
}): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      `${NEST_REST_URL}/login`,
      data
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const logout = async (): Promise<any> => {
  return await axiosInstance.post<any>(`${PATH}/logout/`);
};

export const getUsers = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/users`
    );
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const getCurrentUser = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(
      `${NEST_REST_URL}/current-user`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFormModalControls = async (url: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get<any>(url);
    return response.data;
  } catch (error) {
    if ((error as any)?.response?.status == 401) {
      autoLogout();
    }
    throw error;
  }
};

export const addFormModal = async (data: {
  url: string;
  body: any;
}): Promise<any> => {
  return await axiosInstance.post<any>(data.url, data.body);
};
